import { render } from "./PatientForm.vue?vue&type=template&id=0ecd4d01&scoped=true"
import script from "./PatientForm.vue?vue&type=script&lang=js"
export * from "./PatientForm.vue?vue&type=script&lang=js"

import "./PatientForm.vue?vue&type=style&index=0&id=0ecd4d01&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ecd4d01"]])

export default __exports__